import styled from "styled-components";

export const FooterContainer = styled.footer`
  width: 100%;
  /* extra bottom space so the floating scroll-to-top button never clips the links */
  padding: 24px 16px 56px;
  border-top: 1px solid ${({ theme }) => theme.global.border.tertiary};
  background-color: ${({ theme }) => theme.global.bg.primary};

  @media (min-width: 769px) {
    /* right padding clears the absolute scroll-to-top button (right: 25px + 50px wide) */
    padding: 24px 96px 40px 40px;
  }

  .footer-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  .footer-logo {
    height: 28px;
    width: auto;
  }

  .resources {
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 768px) {
      align-items: flex-end;
    }
  }

  .resources-title {
    margin: 0;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.global.text.tertiary};
  }

  .resources-links {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
  }

  a {
    font-size: 14px;
    text-decoration: none;
    color: ${({ theme }) => theme.global.text.quaternary};
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.global.text.secondary};
    }
  }
`;
